import { User } from '@/api/user'
import { Common } from '@/api/common'
export const UserService = new User()
export const CommonService = new Common()